import React, { Component } from "react";
import { connect } from "react-redux";
import PermIdentity from "@material-ui/icons/PermIdentity";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import TitleCard from "../../mui-components/Card/TitleCard";
import AssetSpreadsheetCreator from "../../containers/domain/asset-spreadsheet/AssetSpreadsheetCreator";
import { getLoggedUser } from "../../reducers/sessionReducer";

class AssetSpreadsheetCreationView extends Component {
  constructor(props) {
    super(props);
    if (props.user.accessProfile === "Assessor") {
      const currDate = new Date();
      this.state = {
        initialValues: {
          assessorId: props.user.id,
          month: currDate.getMonth(),
          year: currDate.getFullYear(),
          headersLine: 1,
          sheetName: "Planilha1",
          headers: {
            name: "Nome do fundo",
            cgeCode: "Código CGE",
            cnpj: "CNPJ",
            segment: "Segmento",
            category: "Categoria",
            subcategory: "Subcategoria",
            isin: "ISIN",
          },
        },
      };
    } else {
      this.state = { initialValues: null };
    }
  }

  render() {
    const { initialValues } = this.state;
    return (
      <GridContainer>
        <ItemGrid xs={12} sm={12} md={9} lg={7}>
          <TitleCard
            icon={PermIdentity}
            titleColor="primary"
            title="Importação de planilha de ativos"
            content={<AssetSpreadsheetCreator initialValues={initialValues} />}
          />
        </ItemGrid>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  user: getLoggedUser(state),
});

export default connect(mapStateToProps)(AssetSpreadsheetCreationView);
